import clsx from "clsx";
import { StoreCategoryModel } from "../../models";
import { useEffect, useState } from "react";
import { isEmpty, ucwords } from "../../helpers";

type Props = {
  selectedCategory?: string;
  categories: StoreCategoryModel[];
  handleScroll: (categoryId: string) => void;
  handleSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const CategorySideMenu: React.FC<Props> = ({
  selectedCategory = "",
  categories,
  handleScroll,
  handleSearch,
}) => {
  const [selectedCategoryId, setSelectedCategoryId] =
    useState<string>(selectedCategory);

  useEffect(() => {
    setSelectedCategoryId(selectedCategory);
  }, [selectedCategory]);

  const handleCategoryClick = (categoryId: string) => {
    setSelectedCategoryId(categoryId);
    handleScroll(categoryId);
  };

  return (
    <>
      <aside className="submenu-sidebar d-none d-lg-block p-0">
        <div className="submenu-search-wrap bg-white position-sticky top-0 p-3">
          <input
            type="search"
            className="search_icon m-0"
            placeholder="Search dishes..."
            onChange={handleSearch}
          />
          {/* <Search size={18} /> */}
        </div>
        <div className="submenu-header px-3">
          {categories
            .filter((parentCategory) => parentCategory.parent_id == "0")
            .map((parentCategory) => {
              const subCategories = categories.filter(
                (category) =>
                  category.parent_id == parentCategory.store_category_id,
              );
              const isParentOrChildSelected =
                selectedCategoryId == parentCategory.store_category_id ||
                subCategories.some(
                  (sc) => sc.store_category_id == selectedCategoryId,
                );

              return (
                <div
                  key={parentCategory.store_category_id}
                  className="menu-custom-select"
                >
                  <div
                    className={clsx(
                      "option-group",
                      "cursor-pointer",
                      isParentOrChildSelected && "selected-item",
                    )}
                    onClick={() =>
                      handleCategoryClick(parentCategory.store_category_id)
                    }
                  >
                    {/* <Grid size={18} /> */}
                    {ucwords(parentCategory.category_name)}
                  </div>

                  <div className="subcategories_container">
                    {!isEmpty(subCategories) && (
                      <div className="submenu">
                        {subCategories.map((subCategory) => (
                          <div
                            key={subCategory.store_category_id}
                            className={clsx(
                              "option",
                              "cursor-pointer",
                              selectedCategoryId ===
                                subCategory.store_category_id &&
                                "selected-submenu",
                            )}
                            onClick={() =>
                              handleCategoryClick(subCategory.store_category_id)
                            }
                          >
                            {ucwords(subCategory.category_name)}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
        </div>
        {/* <div className="menu-recommend-card">
          <h3>Craving something special?</h3>
          <p>Try our chef's recommendations tailored just for you.</p>
          <button type="button">Explore Now</button>
          <Gift className="menu-recommend-icon" />
        </div> */}
      </aside>
    </>
  );
};

export default CategorySideMenu;
